import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux'
import PropTypes from 'prop-types';
import {MyMess} from '../../App';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Dialog from '@material-ui/core/Dialog';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import FormControlLabel from '@material-ui/core/FormControlLabel';

import { GlobalSnackBarUtil } from '../../component/GlobalSnackBar';
import { GetLicenses } from '../../server/WebServiceUrl';
import { asyncMapKopapro } from '../../redux/ducks/domain';
import Axios from 'axios';

export default function AssignDomainDialog(props) {
  const { onClose, value: valueProp, domainId, domain, open, ...other } = props;
  const [selectedValue, setSelectedValue] = React.useState(valueProp || '');
  
  const [isProcessing, setProcessing] = React.useState(false);
//   const radioGroupRef = React.useRef(null);
//   const user = useSelector(state => state.user);
  const [licenses, setLicenses] = useState([]);
  const dispatch = useDispatch();

  React.useEffect(() => {
    if (!open) {
    //   setValue(valueProp);
    } else {
        // console.log('setValue')
        setSelectedValue(valueProp);
        runRefresh();
    }
  }, [valueProp, open]);

  const runRefresh =async () => {
    let res = await Axios.get(GetLicenses);
    if(res && res.status === 200 && res.data && res.data.pass){
      let myLicenses = [];
      myLicenses = res.data.shopLicenses;
      setLicenses(myLicenses);
    }else{
      GlobalSnackBarUtil.open({
        message:MyMess.refreshFail,
        severity:'error'
      })
    }
  }

  const handleEntering = () => {
    // if (radioGroupRef.current != null) {
    //   radioGroupRef.current.focus();
    // }
  };

  const handleCancel = () => {
    setSelectedValue('');
    onClose();
  };

  const handleOk = () => {

    setProcessing(true);
    dispatch(asyncMapKopapro(domainId, selectedValue, mapCallback));
  };

  const mapCallback = (resp) => {
    setProcessing(false);
    if (resp && resp.status === 200 ) {
      GlobalSnackBarUtil.open({
        duration: 10000,
        message: MyMess.formatString(MyMess.domains.alerts.assignedDomain.message, domain, selectedValue),
        severity:'success'
    })
        onClose(true);
    } else if(resp.error) {
        GlobalSnackBarUtil.open({
            message:MyMess.domains.error[resp.error],
            severity:'error'
        })
    } else {
        GlobalSnackBarUtil.open({
            message:MyMess.curd.saveFail,
            severity:'error'
        })
    }
}

  const handleChange = (event) => {
    setSelectedValue(event.target.value);
  };

  return (
    <Dialog
      disableBackdropClick
      disableEscapeKeyDown
      maxWidth="xs"
      onEntering={handleEntering}
      aria-labelledby="confirmation-dialog-title"
      open={open}
      {...other}
    >
      <DialogTitle id="confirmation-dialog-title">{MyMess.formatString(MyMess.domains.assignToKopapro, domain )}</DialogTitle>
      <DialogContent dividers>
        <RadioGroup
        //   ref={radioGroupRef}
          aria-label="ringtone"
          name="ringtone"
          value={selectedValue}
          onChange={handleChange}
        >
          {licenses.map((option) => (
            <FormControlLabel value={option.code} key={option.code} control={<Radio />} label={option.code} />
          ))}
        </RadioGroup>
        {/* TODO: Add remind message if original mapped */}
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={handleCancel} disabled={isProcessing} >
            {MyMess.general.cancel}
        </Button>
        <Button onClick={handleOk} disabled={isProcessing || selectedValue === ''} variant="contained" color="primary">
            {MyMess.assign}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

AssignDomainDialog.propTypes = {
    onClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    value: PropTypes.string.isRequired,
    domainId: PropTypes.string.isRequired,
};
